
































































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import HIVEDivider from "@/components/common/dividers/HIVEDivider.vue";
import HIVESpacer from "@/components/common/HIVESpacer.vue";
import HIVEStepperStep from "@/components/common/steppers/HIVEStepperStep.vue";
import HIVEAlert from "@/components/common/alerts/HIVEAlert.vue";
import HIVETextField from "@/components/common/HIVETextField.vue";
import HIVEButton from "@/components/common/HIVEButton.vue";
import Organization from "@/classes/Organization";
import HeaderField from "@/classes/HeaderField";
import HeaderFieldConstant from "@/classes/helpers/HeaderFieldConstant";
import Axios, { AxiosResponse, AxiosError } from "axios";
import User from "@/classes/User";
import CreateSubscriptionRequest from "@/classes/request_objects/accounts/subscriptions/CreateSubscriptionRequest";
import CreateDomainRequest from "@/classes/request_objects/accounts/organizations/CreateDomainRequest";
import CreateOrganizationAdminRequest from "@/classes/request_objects/accounts/users/CreateOrganizationAdminRequest";
import CreateOrganizationRequest from "@/classes/request_objects/accounts/organizations/CreateOrganizationRequest";
import CreateUpdateOrganizationForm from "@/components/common/forms/CreateUpdateOrganizationForm.vue";
import CreateUpdateSubscriptionForm from "@/components/common/forms/CreateUpdateSubscriptionForm.vue";
import CreateUpdateDomainForm from "@/components/common/forms/CreateUpdateDomainForm.vue";
import CreateUpdateOrganizationAdminForm from "@/components/common/forms/CreateUpdateOrganizationAdminForm.vue";
import CreateUpdateOrganizationUsers from "@/components/common/forms/CreateUpdateOrganizationUsers.vue";
import CreateUpdatePaidLibrariesForm from "@/components/common/forms/CreateUpdatePaidLibrariesForm.vue";
import DateParse from "@/classes/helpers/DateParse";
import OrganizationValidationRule from "@/classes/rules/OrganizationValidationRule";
import PasswordValidationRule from "@/classes/rules/PasswordValidationRule";
import { OrganizationStep } from "@/classes/enums/OrganizationStep";
import { AlertType } from "@/classes/enums/AlertType";
import { IOrganization } from "../classes/interfaces/IOrganization";
import { ISubscription } from "../classes/interfaces/ISubscription";
import OrganizationLibraries from "@/components/common/OrganizationLibraries.vue";
import { Vue, Component } from "vue-property-decorator";
import HIVEDivider from "@/components/common/dividers/HIVEDivider.vue";
import HIVESpacer from "@/components/common/HIVESpacer.vue";
import HIVEStepperStep from "@/components/common/steppers/HIVEStepperStep.vue";
import HIVEAlert from "@/components/common/alerts/HIVEAlert.vue";
import HIVETextField from "@/components/common/HIVETextField.vue";
import HIVEButton from "@/components/common/HIVEButton.vue";
import Organization from "@/classes/Organization";
import HeaderField from "@/classes/HeaderField";
import HeaderFieldConstant from "@/classes/helpers/HeaderFieldConstant";
import Axios, { AxiosResponse, AxiosError } from "axios";
import User from "@/classes/User";
import CreateSubscriptionRequest from "@/classes/request_objects/accounts/subscriptions/CreateSubscriptionRequest";
import CreateDomainRequest from "@/classes/request_objects/accounts/organizations/CreateDomainRequest";
import CreateOrganizationAdminRequest from "@/classes/request_objects/accounts/users/CreateOrganizationAdminRequest";
import CreateOrganizationRequest from "@/classes/request_objects/accounts/organizations/CreateOrganizationRequest";
import CreateUpdateOrganizationForm from "@/components/common/forms/CreateUpdateOrganizationForm.vue";
import CreateUpdateSubscriptionForm from "@/components/common/forms/CreateUpdateSubscriptionForm.vue";
import CreateUpdateDomainForm from "@/components/common/forms/CreateUpdateDomainForm.vue";
import CreateUpdateOrganizationAdminForm from "@/components/common/forms/CreateUpdateOrganizationAdminForm.vue";
import CreateUpdateOrganizationUsers from "@/components/common/forms/CreateUpdateOrganizationUsers.vue";
import CreateUpdateAccessKeysForm from "@/components/common/forms/CreateUpdateAccessKeysForm.vue";
import DateParse from "@/classes/helpers/DateParse";
import OrganizationValidationRule from "@/classes/rules/OrganizationValidationRule";
import PasswordValidationRule from "@/classes/rules/PasswordValidationRule";
import { OrganizationStep } from "@/classes/enums/OrganizationStep";
import { AlertType } from "@/classes/enums/AlertType";
import { IOrganization } from "../classes/interfaces/IOrganization";
import { ISubscription } from "../classes/interfaces/ISubscription";

@Component({
  watch: {
    dialog(val) {
      // tslint:disable-next-line:no-unused-expression
      val || this.closeDialog();
    },
  },
  components: {
    HIVEDivider,
    HIVESpacer,
    HIVEStepperStep,
    HIVEAlert,
    HIVETextField,
    HIVEButton,
    CreateUpdateOrganizationForm,
    CreateUpdateSubscriptionForm,
    CreateUpdateDomainForm,
    CreateUpdateOrganizationAdminForm,
    OrganizationLibraries,
    CreateUpdateOrganizationUsers,
    CreateUpdatePaidLibrariesForm,
    CreateUpdateAccessKeysForm,
  },
})
export default class Organizations extends Vue {
  private organization: Organization = new Organization();
  private organizationAdmin: User = new User();
  private readonly organizationStep = OrganizationStep;
  private search: string = "";
  private isFormValid: boolean = false;
  private dialog: boolean = false;
  private editedIndex: number = -1;
  private updateSubscriptions: boolean = false;
  private headers: Array<HeaderField> = [
    new HeaderField(HeaderFieldConstant.Name, HeaderFieldConstant.orgName),
    new HeaderField(HeaderFieldConstant.Email, HeaderFieldConstant.email),
    new HeaderField(
      HeaderFieldConstant.CreatedAt,
      HeaderFieldConstant.createdAt
    ),
    new HeaderField(
      HeaderFieldConstant.UpdatedAt,
      HeaderFieldConstant.updatedAt
    ),
    new HeaderField("", "action"),
    // new HeaderField('', 'data-table-expand'),
  ];
  private exportDialog = false;
  private expanded: Array = [];
  private isCopied: boolean = false;

  // Computed Properties
  private get initialFormSubmission() {
    return !this.organization.Name || !this.organization.email ? false : true;
  }

  // Change name to organizations
  /** organizations is a computed property that retreives the organizations
   * array either empty or full of organizations from the organizations module.
   */
  private get organizations() {
    return this.$store.getters["organizations/getOrganizations"];
  }

  private get isStepCompleted() {
    return this.$store.getters["organizations/getIsStepCompleted"];
  }

  private get isLoading() {
    return this.$store.getters["organizations/getIsLoading"];
  }

  private get stepNumber() {
    return this.$store.getters["organizations/getStepNumber"];
  }
  private set stepNumber(val: number) {
    this.$store.commit("organizations/setStepNumber", val);
  }

  private get isStepEditable() {
    return this.editedIndex === -1 ? false : true;
  }

  private get isNewOrganization() {
    return this.editedIndex === -1 ? true : false;
  }

  private get formTitle() {
    return this.editedIndex === -1 ? "Create" : "Edit";
  }

  private get formOrgName() {
    return this.editedIndex === -1 ? "Organization" : this.organization.name;
  }

  private get productLicenses() {
    return this.$store.getters["organizations/getProductLicenses"];
  }

  public get alertType() {
    return this.$store.getters["organizations/getAlertTypes"];
  }
  public set alertType(val: string) {
    this.$store.commit("organizations/setAlertType", val);
  }

  public get alertText() {
    return this.$store.getters["organizations/getAlertText"];
  }
  public set alertText(val: string) {
    this.$store.commit("organizations/setAlertText", val);
  }

  // Methods
  /** resetForm resets all of the form inputs and resets validation. */

  /** upsertProductLicenses is an event handler bound to the edit portion of the form for editing product licenses.
   * @param organization
   */
  private upsertProductLicenses(organization: Organization) {
    const requests = [];
    for (const productLicense of this.productLicenses) {
      const createUpdateSubscription = new CreateSubscriptionRequest();
      createUpdateSubscription.organizationId = organization.id;
      createUpdateSubscription.productId = productLicense.productId;
      createUpdateSubscription.serialNumber = productLicense.serialNumber;
      createUpdateSubscription.subscriptionStartDate =
        productLicense.subscriptionStartDate;
      createUpdateSubscription.subscriptionEndDate =
        productLicense.subscriptionEndDate;
      createUpdateSubscription.licenseType = productLicense.licenseType;
      createUpdateSubscription.licenseCount = productLicense.licenseCount;
      if (productLicense.serialNumber !== productLicense.updatedSerialNumber) {
        createUpdateSubscription.updatedSerialNumber =
          productLicense.updatedSerialNumber;
      }
      requests.push(createUpdateSubscription);
    }

    this.$store.dispatch("organizations/upsertProductLicensesAsync", requests);
  }

  private itemExpanded(event) {
    this.$store.commit("libraries/resetQueryValues", event.item);
    if (event.value) {
      this.$store.dispatch("libraries/searchLibrariesAsync", this.orgId);
    }
  }

  private resetForm() {
    this.resetAlerts();
    this.stepNumber = 1;
    this.$refs.form.resetValidation();
    this.dialog = false;
    this.editedIndex = -1;
    this.organization = new Organization();
    this.$store.dispatch("organizations/getOrganizationsAsync");
    this.organizationAdmin = new User();
    this.$store.commit("libraries/resetQueryValues");
  }

  /** resetStepNumber sets the stepnumber back to its default state in Vuex. */
  private resetStepNumber() {
    this.$store.commit("organizations/setStepNumber", 1);
  }

  /** resetAlerts resets all of the alerts. */
  private resetAlerts() {
    this.$store.dispatch("organizations/clearAlertAsync");
    this.$store.dispatch("users/clearAlertAsync");
  }

  /** completeStep is a method that takes in the stepNumber and performs operations dependent on that stepNumber.
   * WARNING: This has not been optimized and can be difficult to troubleshoot and debug.
   */
  private completeStep(stepNumber) {
    let createOrganizationRequest = new CreateOrganizationRequest();

    switch (stepNumber) {
      case this.organizationStep.ORGANIZATION:
        createOrganizationRequest = this.organization;
        this.$store.dispatch(
          "organizations/createOrganization",
          createOrganizationRequest
        );
        break;

      case this.organizationStep.SUBSCRIPTION:
        if (this.organization.productLicenses.length > 0) {
          const requests = [];
          for (const productLicense of this.organization.productLicenses) {
            const createUpdateSubscription = new CreateSubscriptionRequest();
            createUpdateSubscription.organizationId = this.organization.id;
            createUpdateSubscription.productId = productLicense.productId;
            createUpdateSubscription.serialNumber = productLicense.serialNumber;
            createUpdateSubscription.subscriptionStartDate =
              productLicense.subscriptionStartDate;
            createUpdateSubscription.subscriptionEndDate =
              productLicense.subscriptionEndDate;
            createUpdateSubscription.licenseCount = productLicense.licenseCount;
            createUpdateSubscription.licenseType = productLicense.licenseType;

            requests.push(createUpdateSubscription);
          }
          this.$store.dispatch(
            "organizations/upsertProductLicensesAsync",
            requests
          );
        } else {
          this.$store.commit("organizations/setStepNumber", 3);
        }
        break;
      case this.organizationStep.USERS:
        this.$store.commit("organizations/setStepNumber", 4);
        break;
      case this.organizationStep.DOMAIN:
        this.$store.dispatch("organizations/completeDomainStep");
        break;

      case this.organizationStep.ORGANIZATION_ADMIN:
        this.createOrganizationAdmin();
    }
  }

  private closeDialog() {
    this.resetForm();
  }

  private createOrganizationAdmin() {
    const createOrganizationAdminRequest = new CreateOrganizationAdminRequest();
    createOrganizationAdminRequest.firstName = this.organizationAdmin.firstName;
    createOrganizationAdminRequest.lastName = this.organizationAdmin.lastName;
    createOrganizationAdminRequest.emailAddress = this.organizationAdmin.email;
    createOrganizationAdminRequest.description = this.organizationAdmin.description;
    createOrganizationAdminRequest.password = this.organizationAdmin.password;

    this.$store.dispatch(
      "organizations/createOrganizationAdmin",
      createOrganizationAdminRequest
    );
  }

  /** Populates the form with data that belongs to the organization */
  private editOrganization(item) {
    this.editedIndex = this.organizations.indexOf(item);
    this.organization = item;
    this.dialog = true;
    this.$store.dispatch("organizations/editSubscription", this.organization);
  }

  /** Performs the update operation that goes to the Vuex store to call an api. */
  private updateOrganization(organization: Organization) {
    let createOrUpdateOrganization = new CreateOrganizationRequest();
    createOrUpdateOrganization = organization;
    this.$store.dispatch(
      "organizations/updateOrganization",
      createOrUpdateOrganization
    );
  }

  private exportUsersandGroups(item) {
    this.exportDialog = true;
    this.$store.dispatch("users/exportUsersandGroups", item.id);
  }

  private dismissExport() {
    this.exportDialog = false;
  }

  private copyItemId(organizationId) {
    this.isCopied = true;
    navigator.clipboard.writeText(organizationId);
    this.delay(3000);
    //this.isCopied = false
  }

  private delay(ms: number) {
    setTimeout(() => (this.isCopied = false), ms);
  }

  // Lifecycle Hooks
  private created() {
    this.$store.dispatch("organizations/getOrganizationsAsync");
    this.$store.dispatch("organizations/getOrgAdminRole");
    this.$store.dispatch("uicontrols/getProductsListAsync");
    this.$store.dispatch("users/getStatusesAsync");
    this.$store.dispatch("users/getRoles");
  }
}
